module.exports = __webpack_public_path__ + "static/media/qrl.76efbee8.svg";